module.exports = __webpack_public_path__ + "static/media/logo.ede8a952.svg";